<script>
  import { HorizontalBar, mixins } from 'vue-chartjs'

  export default {
    extends: HorizontalBar,
    mixins: [mixins.reactiveProp],
    props: ['chartData', 'options'],
    mounted () {
      this.renderChart(this.chartData, this.options)
    }
  }
</script>

<style>
</style>
